import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import dataModel from '../../../../models/DataModel';
import DataSource from '../../../../dao/DataSource/DataSource';
import './CompanyNavCard.scss';

export class CompanyNavCard extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {  };
  }

  componentDidMount() {
    super.componentDidMount();

    this.companiesDataSource = new DataSource('Company', this.props.company, { company: {} }, this.handleUpdateCompany);
    this.companiesDataSource.get();
  }

  componentWillUnmount() {
    if (this.companiesDataSource) {
      this.companiesDataSource.release();
    }
  }

  handleUpdateCompany(company, action, acData) {
    this.setState({ company: company });
  }

  handleCompanySelection() {
    let parentCompanyId = null;
    if (this.companyCard.id.includes('vendor-company')) { 
      parentCompanyId = this.findParentCompanyId();
    }
    if (!this.ignoreSelection && !this.state.editingTitle) {
      if (this.props.selectCompany) {
        this.props.selectCompany(this.state.company, parentCompanyId);
      }
    }
    this.ignoreSelection = false;
  }

  findParentCompanyId() {
    let currentElement = this.companyCard;
    for (let i = 1; i < 100; i++) {
      currentElement = currentElement.previousSibling;
      if (!currentElement.id.includes('vendor-company')) {
        return parseInt(currentElement.id.split('-')[1], 10);
      }
      if (!currentElement.id) {
        return null;
      }
      
    }
  }

  handleBlur() {
    this.setState({ editingTitle: false });
  }

  handleExpandContract(e) {
    e.stopPropagation();
    if (this.props.handleExpand) {
      this.props.handleExpand(this.state.company);
      this.handleCompanySelection();
    }
  }

  render() {

    const { selected } = this.props;
    const { company } = this.state;

    if (!company) {
      return null;
    }

    let cityState = null;
    if (company.city && company.state) {
      cityState = company.city + ', ' + company.state;
    }
    else if (company.city) {
      cityState = company.city;
    }
    else if (company.state) {
      cityState = company.state;
    }
    else {
      cityState = 'Address Pending';
    }

    let className = 'company-nav-card ' + (selected ? 'selected' : '');
    let expandContract = null;

    if (this.props.hasVendors) {
      className += ' has-vendor';
      expandContract = <div className="expand-contract" onClick={this.handleExpandContract}>{this.props.expanded ? '-' : '+'}</div>;
    }
    else if (this.props.id.includes('vendor-company') || this.props.readOnly) {
      className += ' is-vendor';
    }
    return (

      // Replace with the appropriate HTML
      <div className={className} id={this.props.id} ref={el => this.companyCard = el} onClick={this.handleCompanySelection}>
        {expandContract}
        <div className="info-line">
          <div className="company-info">
            <div className="company-title">
              {company.name}
            </div>
            <div className="company-address">
              {cityState}
            </div>
          </div>
        </div>
        <hr className="separator-line"/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    notifications: state.notifications.notifications,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CompanyNavCard);



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/CompaniesNav/CompanyNavCard/index.js